import React from "react";
import PropTypes from "prop-types";

import { Button, Card, Empty, List, Space, Tag, Typography } from "antd";

import { CreditCardOutlined } from "@ant-design/icons";

import {
    PAYMENT_METHOD_LABELS,
    formatAmount,
    purchaseStage
} from "../../../../../constants/marketplaceCheckout";

const { Text, Title } = Typography;

const ACTION_LABELS = {
    PAY: "Payer maintenant",
    FOLLOW_PAYMENT: "Suivre le paiement",
    TRACK: "Suivi de la commande"
};

/** Accords dont le checkout est confirmé : paiement, reprise, suivi. */
const PaymentList = ({ agreements = [], currentUserId, onPay }) => {
    if (!agreements.length) {
        return <Empty description="Aucun paiement" />;
    }

    return (
        <List
            dataSource={agreements}
            rowKey={agreement => agreement.id}
            renderItem={agreement => {
                const stage = purchaseStage(agreement, currentUserId);
                const method = PAYMENT_METHOD_LABELS[agreement.checkoutPaymentMethod]?.title;

                return (
                    <List.Item>
                        <Card style={{ width: "100%", borderRadius: 12 }}>
                            <Space style={{ width: "100%", justifyContent: "space-between" }} align="start">
                                <div>
                                    <Title level={5} style={{ marginTop: 0 }}>
                                        <CreditCardOutlined /> Paiement
                                    </Title>
                                    <Text type="secondary">{method || "Mode de paiement à définir"}</Text>
                                </div>
                                <Tag color={stage.color}>{stage.label}</Tag>
                            </Space>
                            <div style={{ marginTop: 16 }}>
                                <Text strong>Montant : </Text>
                                {formatAmount(agreement.totalAmount ?? agreement.productAmount, agreement.currency)}
                            </div>
                            {stage.action && stage.action !== "VALIDATE" && (
                                <Button
                                    type={stage.action === "TRACK" ? "default" : "primary"}
                                    style={{ marginTop: 16 }}
                                    disabled={!agreement.inquiryId}
                                    onClick={() => onPay?.(agreement)}
                                >
                                    {ACTION_LABELS[stage.action]}
                                </Button>
                            )}
                        </Card>
                    </List.Item>
                );
            }}
        />
    );
};

PaymentList.propTypes = {
    agreements: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        inquiryId: PropTypes.string,
        buyerId: PropTypes.string,
        status: PropTypes.string,
        currency: PropTypes.string,
        checkoutPaymentMethod: PropTypes.string,
        totalAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        productAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    })),
    currentUserId: PropTypes.string,
    onPay: PropTypes.func
};

export default PaymentList;
